// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PrivacyPage_wrapper__ZveYv","title":"PrivacyPage_title__XQ8I9","content":"PrivacyPage_content__39YXp"};